var _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.8094C8.5 12.5794 9.1 13.2094 9.83 13.2094H11.33C11.97 13.2094 12.49 12.6594 12.49 11.9894C12.49 11.2594 12.17 10.9994 11.7 10.8294L9.3 9.98938C8.82 9.81938 8.5 9.55938 8.5 8.82938C8.5 8.15938 9.02 7.60938 9.66 7.60938H11.16C11.9 7.61937 12.5 8.23938 12.5 9.00938",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.2578V13.9978",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.82031V7.60031",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.49 18.3902C14.9028 18.3902 18.48 14.8129 18.48 10.4002C18.48 5.9874 14.9028 2.41016 10.49 2.41016C6.07724 2.41016 2.5 5.9874 2.5 10.4002C2.5 14.8129 6.07724 18.3902 10.49 18.3902Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.48 20.2902C14.38 21.5602 15.85 22.3902 17.53 22.3902C20.26 22.3902 22.48 20.1702 22.48 17.4402C22.48 15.7802 21.66 14.3102 20.41 13.4102",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.d3062614f531bbea363be5832f871841.svg";
export { ForwardRef as ReactComponent };